export function emptyUnreadCounts() {
    return {
        muted: 0,
        unmuted: 0,
        mentions: false,
    };
}
export function emptyCombinedUnreadCounts() {
    return {
        chats: emptyUnreadCounts(),
        threads: emptyUnreadCounts(),
    };
}
export function mergeUnreadCounts(unreadMessages, muted, mentions, counts, increment = 1) {
    const toAdd = unreadMessages > 0 ? increment : 0;
    return {
        mentions: counts.mentions || mentions,
        unmuted: muted ? counts.unmuted : counts.unmuted + toAdd,
        muted: muted ? counts.muted + toAdd : counts.muted,
    };
}
export function mergeListOfCombinedUnreadCounts(counts) {
    return counts.reduce((result, count) => mergePairOfCombinedUnreadCounts(result, count), emptyCombinedUnreadCounts());
}
export function mergePairOfCombinedUnreadCounts(a, b) {
    return {
        chats: mergePairOfUnreadCounts(a.chats, b.chats),
        threads: mergePairOfUnreadCounts(a.threads, b.threads),
    };
}
export function mergePairOfUnreadCounts(a, b) {
    return {
        muted: a.muted + b.muted,
        unmuted: a.unmuted + b.unmuted,
        mentions: a.mentions || b.mentions,
    };
}
export function mergeCombinedUnreadCounts({ chats, threads }) {
    return mergePairOfUnreadCounts(chats, threads);
}
